import { Links } from '@/src/generated/graphql'
import { AnchorHTMLAttributes, PropsWithChildren } from 'react'
import { convertDirectusLinkToHref } from '@/src/components/common/Link/index'
import NextLink from 'next/link'

export default function LinkClient(
  _: PropsWithChildren<AnchorHTMLAttributes<HTMLAnchorElement> & { directusLink: Links }>,
) {
  const { directusLink, ...anchorProps } = _

  const href = convertDirectusLinkToHref(directusLink)

  if (href === null) return null

  return (
    <NextLink {...anchorProps} href={anchorProps.href ?? href}>
      {_.children}
    </NextLink>
  )
}
